import React from "react";
import { ScanEye } from "lucide-react";
import { InspectorVisibilityEyeButton } from "../components/ui/InspectorVisibilityEyeButton";
import { InspectorVisibilitySection } from "../components/property-panels/InspectorVisibilitySection";
import VisibilityIconRow from "../components/property-panels/VisibilityIconRow";
import { useConstraintVisibilityControls } from "./useConstraintVisibilityControls";
import { useViewerActions, useViewerStore } from "../stores/viewerStore";

const EqualityVisibilityToolbar = ({
  equalityUuid,
  className = "",
  sectionTitle = "Constraint Visibility",
}) => {
  const equalityMarkerVisibility = useViewerStore((s) => s.equalityMarkerVisibility);
  const viewerActions = useViewerActions();
  const thisEqualityMarkerVisible = equalityUuid
    ? equalityMarkerVisibility[equalityUuid] !== false
    : true;

  const { state, focusDisabled, toggleFocus } = useConstraintVisibilityControls({
    equalityUuid: equalityUuid ?? null,
    enabled: Boolean(equalityUuid),
  });

  return (
    <InspectorVisibilitySection
      sectionTitle={sectionTitle}
      className={className}
      headerActions={
        <InspectorVisibilityEyeButton
          visible={thisEqualityMarkerVisible}
          onToggle={() =>
            equalityUuid &&
            viewerActions.setEqualityMarkerVisibility(equalityUuid, !thisEqualityMarkerVisible)
          }
          tooltipWhenOn="This constraint's markers are visible — click to hide"
          tooltipWhenOff="This constraint's markers are hidden — click to show"
          ariaLabel="Toggle selected constraint marker visibility"
        />
      }
    >
      <VisibilityIconRow
        actions={[
          {
            key: "focus",
            title: "Display selected constraint only",
            on: state.focus,
            onClick: toggleFocus,
            disabled: focusDisabled,
            Icon: ScanEye,
          },
        ]}
      />
    </InspectorVisibilitySection>
  );
};

export default React.memo(EqualityVisibilityToolbar);
